import { render } from "./Scroll.vue?vue&type=template&id=6561866b&scoped=true"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"

import "./Scroll.vue?vue&type=style&index=0&id=6561866b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6561866b"]])

export default __exports__